import { CrossSellingPointer } from "../../others/crossSellingPointer.js";
import { RML } from "../names.js";
/**
 * Attachment details in grid / list view.
 */ const crossRmlAttachmentDetails = ()=>CrossSellingPointer.waitForVisibleElement("body.wp-admin.upload-php .attachment-info > .details:visible, body.wp-admin.post-php.post-type-attachment #post-body-content #titlewrap:visible", RML, "attachment-details");
export { crossRmlAttachmentDetails };
